import { graphql, useStaticQuery } from 'gatsby';
import FAQComponent from '../common/FAQComponent';

function FAQHome({ hideHelpAndSupport }) {
    const { faq } = useStaticQuery(graphql`
        {
            faq: allContentfulFaqHeader(filter: { name: { eq: "Home Page" } }) {
                edges {
                    node {
                        faq {
                            visibility
                            question
                            response {
                                raw
                            }
                        }
                    }
                }
            }
        }
    `);

    return <FAQComponent faqs={[faq]} currentPage='Home' hideHelpAndSupport={hideHelpAndSupport} />;
}

export default FAQHome;
